const doc = [({"en":({"js":({"components":({"text_keys":({"partial":({"update_text_keys":"Update text keys", "text_keys_were_updated":"The text keys were updated."})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;